var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const updateDocumentMetadataAction = (ws, documentId, metadataFields) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield new Promise(resolve => {
        ws.send('request:/metadata:patch', { routeId: documentId, metadata: buildMetadataObject(metadataFields) }, (data) => resolve(data));
    });
    if (result.statusCode !== 200) {
        throw Error('Update metadata failed.');
    }
});
const buildMetadataObject = (metadataFields) => {
    const metadata = {};
    for (const metadataField of metadataFields) {
        metadata[metadataField.name] = metadataField.value;
    }
    return metadata;
};
export default updateDocumentMetadataAction;
